/**
 * Options:
 * not_single_product: true - treat bundle as a bundle even if only one product
 */

var bundles_array = [
  {
    bundle_name: 'The Starter Kit',
    bundle_class: 'The_Starter_Kit',
    sold: false,
    bundle_discount: 16.730038, 
    bundle_components: [
      {id: 32917301756000, price: 69.00, replace_variant: 32917301788768, price: 69.00}, // FaceBlaster™
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 32183192780896, price:46.00}, // Ashley Black's Kryopack™ Back And Abs Wrap
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Beginner Kit',
    bundle_class: 'Beginner_Kit',
    sold: false,
    bundle_discount: 41.8410042, 
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 32183156179040, price:22.00}, // Ashley Black's Kryopack™ Wrap
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  }
];
var upsell_bundles_array = [];
var bundles_per_handle = {};
var bundle_upsell = {};
var subscribtion_products = [];
var fake_product_name = {};
var discount_products_base_on_qty = {};
var us_checkout_only = {};
var doubled_products = {};
var bf_2022_sale = {};
var bundle_description = {};
